import { v4 } from "uuid";

import { IAppointmentDetailsDto } from "modules/user/application/types/IAppointmentDetailsDto";
import { AppointmentStatus } from "modules/user/application/types/AppointmentStatus";

export const createUserAppointment = (
  userAppointment?: Partial<IAppointmentDetailsDto>
): IAppointmentDetailsDto => {
  const id = userAppointment?.appointmentId ?? v4();
  return {
    appointmentId: id,
    orgUnitFullName: `Org unit ${id}`,
    email: `email${id}@test.pl`,
    userPhone: "666 666 666",
    userName: "Januesz Kowalskyj",
    queueId: "123123",
    queueName: `Kolejka Kolejka ${id}`,
    groupName: `Grupppa grupaa Grupa ${id}`,
    startDate: "2021-05-12, 11:10:00",
    endDate: "2021-05-07, 11:15:00",
    status: AppointmentStatus.Approved,
    details:
      "Detale na temat wizyty aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaabbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb",
    cancellationReason: "Powód usunięcia",
    createDate: "2021-05-05, 11:10:00",
    friendlyUrl: 'default',
    ...userAppointment,
  };
};
